// import composables
import useApi from '@/composables/useApi/useApi';
import { auth } from '@/constants/ApiList';
import VersionPaths from '@/enums/VersionPaths';
import { IApiVersion } from '@/interfaces/IApiVersion';
import AuthApiVersion from '@/types/AuthApiVersion';

const { fetchData } = useApi();

const baseUrl = auth.baseUrl;
function logInUser(username: string, password: string, otp: string = '') {
  return fetchData(
    baseUrl,
    { path: 'Auth/SignIn', method: 'POST', requireAuth: false },
    {
      email: username,
      password,
      otp,
    }
  );
}

function logOutUser(jwtToken: string) {
  return fetchData(
    baseUrl,
    { path: 'Auth/SignOut', method: 'POST', requireAuth: false },
    {
      jwtToken,
    }
  );
}

function changeUserPassword(
  userId: string,
  oldPassword: string,
  newPassword: string
) {
  return fetchData(
    baseUrl,
    {
      path: 'Account/UpdatePassword',
      method: 'PUT',
      requireAuth: true,
    },
    {
      userId,
      oldPassword,
      newPassword,
    }
  );
}

function tokenRefresh(jwtToken: string) {
  return fetchData(
    baseUrl,
    { path: 'Auth/Refresh', method: 'POST', requireAuth: false },
    {
      jwtToken,
    }
  );
}

async function apiinfo(): Promise<IApiVersion | null> {
  const { data, error } = await fetchData(baseUrl, {
    path: VersionPaths.AUTH_API,
    method: 'GET',
    requireAuth: false,
  }).json<AuthApiVersion>();

  if (error.value) {
    console.error('Error fetching API info:', error.value);
    return null;
  }

  // Map AuthApiVersion to IApiVersion
  const apiVersion: IApiVersion = {
    name: data.value?.appName || 'bo-identity-api',
    title: data.value?.displayName || 'Identity API',
    version: data.value?.appVersion || '',
    lastUpdated: data.value?.appReleaseDate || '',
    environment: data.value?.environment || '',
    releaseSignature: data.value?.appReleaseSignature || '',
    lastFetched: new Date(),
    isLoading: false,
    isSuccess: true,
  };

  return apiVersion;
}

const identityService = {
  logInUser,
  logOutUser,
  changeUserPassword,
  tokenRefresh,
  apiinfo,
};
export default identityService;
